import React, { useState } from 'react';
import api from '../services/api';
import './Modal.css';

const PopulateSharksModal = ({ onClose, setBannerMessage }) => {
    const [numSharks, setNumSharks] = useState(240);
    const [smallest, setSmallest] = useState(80);
    const [largest, setLargest] = useState(1000);
    const [password, setPassword] = useState('');
    const [isPopulating, setIsPopulating] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsPopulating(true);
        setBannerMessage('');
        try {
            const formData = new FormData();
            formData.append('password', password);
            const response = await api.post(`/admin/populate-sharks?num_sharks=${numSharks}&smallest=${smallest}&largest=${largest}`, formData);
            setBannerMessage(response.data.message);
        } catch (error) {
            setBannerMessage('An error occurred while populating sharks.');
        } finally {
            setIsPopulating(false);
            onClose();
        }
    };

    return (
        <div className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div className="modal-content">
                <h2>Populate Sharks</h2>
                {isPopulating ? (
                    <p>Populating sharks, please wait...</p>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="numSharks">Number of Sharks per Round:</label>
                            <input
                                type="number"
                                id="numSharks"
                                value={numSharks}
                                onChange={(e) => setNumSharks(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="smallest">Smallest Shark (lbs):</label>
                            <input
                                type="number"
                                id="smallest"
                                value={smallest}
                                onChange={(e) => setSmallest(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="largest">Largest Shark (lbs):</label>
                            <input
                                type="number"
                                id="largest"
                                value={largest}
                                onChange={(e) => setLargest(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Admin Password:</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                autoComplete="current-password"
                            />
                        </div>
                        <div className="modal-actions">
                            <button type="submit" className="btn btn-primary">Populate</button>
                            <button type="button" onClick={onClose} className="btn btn-secondary">Cancel</button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default PopulateSharksModal;
